export const getCurrentUser = (state) => {
  return state.auth.currentUser;
};
